export { ClaimsDirective } from './claims.directive'
export { DirectivesModule } from './directives.module'


// WEBPACK FOOTER //
// ./src/app/shared/directives/index.ts